// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Restaumatic_Form_Internal from "../Restaumatic.Form.Internal/index.js";
import * as Safe_Coerce from "../Safe.Coerce/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Specular_FormField from "../Specular.FormField/index.js";
import * as Specular_Ref from "../Specular.Ref/index.js";
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var pure = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Host.applicativeHost);
var write = /* #__PURE__ */ Specular_Ref.write(Effect_Class.monadEffectEffect);
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var coerce = /* #__PURE__ */ Safe_Coerce.coerce();
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Host.bindHost);
var apply = /* #__PURE__ */ Control_Apply.apply(Specular_FRP_Base.applyDynamic);
var WithIndeterminate = function (x) {
    return x;
};
var Checked = /* #__PURE__ */ (function () {
    function Checked() {

    };
    Checked.value = new Checked();
    return Checked;
})();
var Unchecked = /* #__PURE__ */ (function () {
    function Unchecked() {

    };
    Unchecked.value = new Unchecked();
    return Unchecked;
})();
var Indeterminate = /* #__PURE__ */ (function () {
    function Indeterminate() {

    };
    Indeterminate.value = new Indeterminate();
    return Indeterminate;
})();
var semigroupTristate = {
    append: function (v) {
        return function (v1) {
            if (v instanceof Checked && v1 instanceof Checked) {
                return Checked.value;
            };
            if (v instanceof Unchecked && v1 instanceof Unchecked) {
                return Unchecked.value;
            };
            return Indeterminate.value;
        };
    }
};
var hasFieldIdWithIndetermina = function (dictHasFieldId) {
    var getFieldId = Restaumatic_Form_Internal.getFieldId(dictHasFieldId);
    return {
        getFieldId: function (v) {
            return getFieldId(v.field);
        }
    };
};
var genericTristate_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Checked.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Unchecked.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return Indeterminate.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Form.Checkbox (line 21, column 1 - line 21, column 35): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Checked) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Unchecked) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Indeterminate) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at Restaumatic.Form.Checkbox (line 21, column 1 - line 21, column 35): " + [ x.constructor.name ]);
    }
};
var showTristate = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericTristate_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Checked";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Unchecked";
        }
    }))(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Indeterminate";
        }
    }))))
};
var eqTristate = {
    eq: function (x) {
        return function (y) {
            if (x instanceof Checked && y instanceof Checked) {
                return true;
            };
            if (x instanceof Unchecked && y instanceof Unchecked) {
                return true;
            };
            if (x instanceof Indeterminate && y instanceof Indeterminate) {
                return true;
            };
            return false;
        };
    }
};
var asCheckboxStateTristate = {
    toTristate: identity,
    fromBoolean: function (b) {
        if (b) {
            return Checked.value;
        };
        return Unchecked.value;
    }
};
var asCheckboxStateMaybeBoole = {
    toTristate: function (v) {
        if (v instanceof Data_Maybe.Just && v.value0) {
            return Checked.value;
        };
        return Unchecked.value;
    },
    fromBoolean: function (v) {
        if (v) {
            return new Data_Maybe.Just(true);
        };
        if (!v) {
            return Data_Maybe.Nothing.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Form.Checkbox (line 55, column 1 - line 59, column 30): " + [ v.constructor.name ]);
    }
};
var asCheckboxStateBoolean = {
    toTristate: function (b) {
        if (b) {
            return Checked.value;
        };
        return Unchecked.value;
    },
    fromBoolean: identity
};
var toTristate = function (dict) {
    return dict.toTristate;
};
var toTristate1 = /* #__PURE__ */ toTristate(asCheckboxStateBoolean);
var isCheckboxFieldFormFieldB = {
    checkboxInput: function (field) {
        return pure({
            onChange: function (value) {
                return write(Specular_FormField.editRef(field))(value);
            },
            displayedValue: map(toTristate1)(Specular_Ref.value(Specular_FormField.editRef(field)))
        });
    }
};
var fromBoolean = function (dict) {
    return dict.fromBoolean;
};
var fromBoolean1 = /* #__PURE__ */ fromBoolean(asCheckboxStateTristate);
var isCheckboxFieldRef = function (dictAsCheckboxState) {
    var fromBoolean2 = fromBoolean(dictAsCheckboxState);
    var toTristate2 = toTristate(dictAsCheckboxState);
    return {
        checkboxInput: function (f) {
            return pure({
                onChange: function (value) {
                    return write(f)(fromBoolean2(value));
                },
                displayedValue: map(toTristate2)(Specular_Ref.value(f))
            });
        }
    };
};
var checkboxInput = function (dict) {
    return dict.checkboxInput;
};
var isCheckboxFieldMappedFiel = function (dictTypeEquals) {
    return function (dictIsCheckboxField) {
        var checkboxInput1 = checkboxInput(dictIsCheckboxField);
        return {
            checkboxInput: function (field$prime) {
                var v = coerce(field$prime);
                var tristateToBool = function (v1) {
                    if (v1 instanceof Checked) {
                        return true;
                    };
                    if (v1 instanceof Unchecked) {
                        return false;
                    };
                    if (v1 instanceof Indeterminate) {
                        return false;
                    };
                    throw new Error("Failed pattern match at Restaumatic.Form.Checkbox (line 79, column 9 - line 82, column 33): " + [ v1.constructor.name ]);
                };
                return bind(checkboxInput1(v.field))(function (v1) {
                    return pure({
                        displayedValue: map(function ($102) {
                            return fromBoolean1(v.mapping(tristateToBool($102)));
                        })(v1.displayedValue),
                        onChange: function ($103) {
                            return v1.onChange(v.mapping($103));
                        }
                    });
                });
            }
        };
    };
};
var isCheckboxFieldWithId = function (dictIsCheckboxField) {
    var checkboxInput1 = checkboxInput(dictIsCheckboxField);
    return {
        checkboxInput: function (v) {
            return checkboxInput1(v.value0.field);
        }
    };
};
var isCheckboxFieldWithIndete = function (dictIsCheckboxField) {
    var checkboxInput1 = checkboxInput(dictIsCheckboxField);
    return function () {
        return {
            checkboxInput: function (v) {
                return bind(checkboxInput1(v.field))(function (v1) {
                    return pure({
                        displayedValue: apply(map(function (v2) {
                            return function (v3) {
                                if (v3) {
                                    return Indeterminate.value;
                                };
                                return v2;
                            };
                        })(v1.displayedValue))(v.indeterminate),
                        onChange: v1.onChange
                    });
                });
            }
        };
    };
};
export {
    checkboxInput,
    fromBoolean,
    toTristate,
    Checked,
    Unchecked,
    Indeterminate,
    WithIndeterminate,
    eqTristate,
    genericTristate_,
    showTristate,
    semigroupTristate,
    isCheckboxFieldWithId,
    asCheckboxStateBoolean,
    asCheckboxStateMaybeBoole,
    asCheckboxStateTristate,
    isCheckboxFieldRef,
    isCheckboxFieldMappedFiel,
    isCheckboxFieldFormFieldB,
    isCheckboxFieldWithIndete,
    hasFieldIdWithIndetermina
};
